'use client';
import { useMounted } from '@/lib/hooks/useMounted';
import styles from './miniReviewStylingOverride.module.css';
import Image from 'next/image';
import { useLayoutContext } from '@/components/Layout/LayoutProvider';
import miniReviewsAvatar from '@/public/images/mini-reviews-avatar.png';

export const ReviewAvatars = () => {
  return (
    <div style={{ justifyContent: 'flex-start', alignItems: 'center', display: 'inline-flex' }}>
      <Image
        width={144}
        height={64}
        style={{
          objectFit: 'cover',
          position: 'relative',
          zIndex: 1,
        }}
        src={miniReviewsAvatar}
        alt='Google reviews'
      />
    </div>
  );
};

export default function MiniReviews() {
  const isMounted = useMounted();
  const { trustIndexId02Short } = useLayoutContext();

  if (!isMounted) {
    return <div className={`${styles.trustindexCustomPromo} min-h-[128px]`}></div>;
  }

  return (
    <div className={styles.trustindexCustomPromo}>
      <ReviewAvatars />
      <div data-src={`https://cdn.trustindex.io/loader.js?${trustIndexId02Short}`}></div>
    </div>
  );
}
